import * as React from 'react';
import * as PropTypes from 'prop-types';
import {ButtonProps, ButtonState} from '../types/components';
import AssetsManager from '../utils/AssetsManager';

class Button extends React.Component<ButtonProps, ButtonState> {

    static propTypes = {
        text: PropTypes.string,
        onPress: PropTypes.func,
        type: PropTypes.oneOf(['default', 'outlined', 'link', 'small-outlined', 'squared', 'circle-small-outlined']),
        disabled: PropTypes.bool,
        customClass: PropTypes.string
    };

    static defaultProps = {
        type: 'default',
        disabled: false,
        customClass: ''
    };

    constructor(props) {
        super(props);
        // @ts-ignore
        this.state = {
            buttonStyle: ''
        };
    }

    componentDidMount() {
        this.setStyles(this.props.type);
    }

    setStyles = (type) => {
        switch (type) {
            case 'outlined':
                this.setState({
                    buttonStyle: `btn rounded btn-outline-info ${this.props.customClass} `
                });
                return;
            case 'small-outlined':
                this.setState({
                    buttonStyle: `btn rounded btn-outline-info small button-small-enabled ${this.props.customClass} `
                });
                return;
            case 'circle-small-outlined':
                this.setState({
                    buttonStyle:
                        `btn rounded btn-outline-info circle-small button-small-enabled ${this.props.customClass} `
                });
                return;
            case 'link':
                this.setState({
                    buttonStyle: `btn-link ${this.props.customClass} `
                });
                return;
            case 'squared':
                this.setState({
                    buttonStyle: `btn btn-info ${this.props.customClass} `
                });
                return;
            default:
                this.setState({
                    buttonStyle: `btn rounded btn-info ${this.props.customClass} `
                });
                return;
        }
    }

    render() {
        const {text, onPress, disabled, icon} = this.props;
        const {buttonStyle} = this.state;
        return (
            <button onClick={() => onPress()}
                    className={buttonStyle} type="button" disabled={disabled}>
                {icon ? <img src={AssetsManager(icon)} width="16" className={text ? 'mr-1' : ''}/> : null} {text}
            </button>

        );
    }
}

export default Button;
